<template>
	<div id="app">
		<transition :name="transitionName">
			<keep-alive :include="keepAlive">
				<router-view class="com-page-container"></router-view>
			</keep-alive>
		</transition>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
	name: 'App',
	computed: {
		...mapState({
			routerHistory: state => state.routerHistory,
			tabbarKeepAlive: state => state.tabbarKeepAlive
		}),
		...mapGetters(['keepAlive'])
	},
	watch: {
		$route(to, from) {
			console.log('isBack', this.$router.isBack)
			// console.log('this.$router', this.$router)
			// console.log('to', to)
			// console.log('from', from)
			// 待实现：仅监听路由返回(现在的isBack包括前进)
			if (this.$router.isBack) {
				this.transitionName = 'com-slide-right'
			} else if (!from.name || this.tabbarKeepAlive.includes(to.name)) {
				this.transitionName = ''
			} else {
				this.transitionName = 'com-slide-left'
			}
			this.$router.isBack = false
		}
	},
	data() {
		return {
			transitionName: 'com-fade',
			dom: []
		}
	},
	methods: {
		async onDeviceReady() {
			var that = this
			document.addEventListener('backbutton', that.onBackKeyDown, false)
			that.initJPush()
			// 设备的uuid
			console.log('uuid:' + device.uuid)
			
			let chcp = window.chcp;
			// 检测更新
			chcp.fetchUpdate((error, data) => {
				if (error) {
					alert(JSON.stringify(error))
					alert('--更新版本异常，或其他错误--', error.code, error.description);
					if (error.code === -2) {
						var dialogMessage = '有新的版本是否下载';
						//调用升级提示框 点击确认会跳转对应商店升级
						chcp.requestApplicationUpdate(dialogMessage, null, null);
					}
				}
				// 服务器版本信息
				alert('--更新的版本信息--', data.config);
				// 版本信息
				chcp.getVersionInfo((err, data) => {
					alert('服务器应用时间版本: ' + data.readyToInstallWebVersion);
					alert('当前应用时间版本： ' + data.currentWebVersion);
					alert('当前应用version name: ' + data.appVersion);
				});
			});

			// window.plugins.sim.getSimInfo(function(res){
			//   var html = [];
			//   html.push('carrierName:'+res.carrierName);
			//   html.push('countryCode:'+res.countryCode);
			//   html.push('mcc:'+res.mcc);
			//   html.push('mnc:'+res.mnc);
			//   html.push('phoneNumber:'+res.phoneNumber);
			//   html.push('callState:'+res.callState);
			//   html.push('dataActivity:'+res.dataActivity);
			//   html.push('networkType:'+res.networkType);
			//   html.push('phoneType:'+res.phoneType);
			//   html.push('simState:'+res.simState);
			//   // that.dom = html.join('\n');
			//   alert(html.join(','))
			// }, function(){
			//   // that.dom ='error';
			//   alert('error')
			// });

			// new Promise(function (resolve, reject) {
			//   var permissions = cordova.plugins.permissions;
			//   var list = [
			//     permissions.ACCESS_COARSE_LOCATION,
			//     permissions.CAMERA,
			//     permissions.WRITE_EXTERNAL_STORAGE
			//   ];
			//   permissions.requestPermissions(list, function(status) {
			//     resolve(status)
			//   }, function () {
			//     reject()
			//   })
			// }).then(function(status){
			//   alert(status)
			// }).catch(function () {
			//   //获取权限失败！！！
			//   alert('permission request fail')
			// })
			await this.checkPermissions()
		},
		// 监听返回键
		onBackKeyDown() {
			var that = this
			console.log('currentRouteName', that.$router.currentRoute.name)
			if (that.tabbarKeepAlive.includes(that.$router.currentRoute.name)) {
				console.log('111')
				that.$toast({
					message: '再按一次退出',
					position: 'bottom'
				})
				document.addEventListener('backbutton', that.exitApp, false) //绑定退出事件
				setTimeout(() => {
					document.removeEventListener('backbutton', that.exitApp, false)
				}, 2000)
			} else {
				console.log('222')
				that.$router.go(-1)
			}
		},
		// 关闭app
		exitApp() {
			var that = this
			navigator.app.exitApp()
		},
		async checkPermissions() {
			let permissions = cordova.plugins.permissions
			let list = [permissions.ACCESS_COARSE_LOCATION, permissions.CAMERA, permissions.WRITE_EXTERNAL_STORAGE]
			permissions.requestPermissions(
				list,
				status => {
					console.log('success', status)
				},
				error => {
					console.log('error', error)
				}
			)
		},
		initJPush() {
			console.log('===[初始化极光推送]===')
			try {
				window.JPush.init()
				// alert('initjpushok')
				document.addEventListener(
					'jpush.receiveRegistrationId',
					function(event) {
						// 18071adc03d621cda7d 荣耀7debug
						// 1a0018970a788f0d3b3 荣耀20release签名apk,卸载再安装不变
						// 140fe1da9e766561d7e 荣耀20debug,卸载再安装会变
						// 140fe1da9e768e0d463 荣耀20debug
						// 1507bfd3f7184ed2d50 荣耀20debug
						alert(event.registrationId)
					},
					false
				)
				window.JPush.setDebugMode(true)
				if (device.platform != 'Android') {
					window.JPush.setApplicationIconBadgeNumber(0)
				}
			} catch (exception) {
				alert(exception)
			}
			// document.addEventListener(
			// 	'jpush.receiveRegistrationId',
			// 	function(event) {
			// 		alert('receiveRegistrationId' + JSON.stringify(event))
			// 		// alert("receiveRegistrationId" + event.registrationId);
			// 	},
			// 	false
			// )
			document.addEventListener(
				'jpush.openNotification',
				function(event) {
					//打开通知
					try {
						console.log('openNotification', JSON.stringify(event))
						alert(JSON.stringify(event))
						//获取极光推送附带的参数
						var id = event.extras.id
						var lx = event.extras.lx
						//相应的动作
						alert(id + '===' + lx)
					} catch (exception) {
						console.log('JPushPlugin:onOpenNotification' + exception)
					}
				},
				false
			)
			document.addEventListener(
				'jpush.receiveNotification',
				function(event) {
					//收到通知
					try {
						console.log('receiveNotification', JSON.stringify(event))
						alert(JSON.stringify(event))
						//获取极光推送附带的参数
						var id = event.extras.id
						var lx = event.extras.lx
						//相应的动作
						alert(id + '===' + lx)
					} catch (exception) {
						console.log('JPushPlugin:onReceiveNotification' + exception)
					}
				},
				false
			)
		}
	},
	created() {
		alert('版本3')
		var that = this
		document.addEventListener('deviceready', that.onDeviceReady, false)
	},
	mounted() {},
	destroyed() {
		var that = this
		document.removeEventListener('backbutton', that.exitApp, false)
		document.removeEventListener('backbutton', that.onBackKeyDown, false)
	}
}
</script>

<style lang="less" scoped>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	// text-align: center;
	color: @font-color;
}
</style>
